<template>
  <div class="left-chart-3">
    <div class="lc3-header">收件省份占比</div>
    <div class="lc3-details">收件总数<span>{{ provinceTotal }}</span></div>
    <div id="province"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'LeftChart3',
  props: {
    provinces: {
      type: Array,
      default: () => []
    },
    provinceTotal: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      echarts: null
    }
  },
  watch: {
    provinces () {
      this.setOption()
    }
  },
  beforeDestroy () {
    this.echarts && this.echarts.dispose()
  },
  mounted () {
    this.echarts = echarts.init(document.getElementById('province'))
    this.setOption()
  },
  methods: {
    setOption () {
      let province = this.provinces.map(item => {
        return {
          name: item.provinceName,
          value: item.totleCount
        }
      })
      let options = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: '0',
          orient: 'vertical',
          textStyle: { color: '#fff' }
        },
        series: [
          {
            name: '快递平台总数',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: province
          }
        ]
      }
      this.echarts.setOption(options)
    }
  }
}
</script>

<style lang="less">
#province{
  width: 100%;
  height: 100%;
}
.left-chart-3 {
  width: 100%;
  height: 33%;
  display: flex;
  flex-direction: column;

  .lc3-header {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    text-indent: 20px;
    margin-top: 10px;
  }

  .lc3-details {
    height: 40px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc3-chart {
    flex: 1;
  }
}
</style>
